var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogistics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.743,
    height: 26.362,
    viewBox: "0 0 33.743 26.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "truck-line",
    d: "M30.65,12.341H26.558V7.057A1.04,1.04,0,0,0,25.534,6H3.023A1.04,1.04,0,0,0,2,7.057V26.078a1.04,1.04,0,0,0,1.023,1.057H4.046V8.114H24.511V20.478a6.4,6.4,0,0,1,1.6-.211h.45V14.454H30.65A2.081,2.081,0,0,1,32.7,16.568v1.057H28.6v2.114H32.7v5.284H30.241a4.589,4.589,0,0,0-8.534,0H14.719A4.6,4.6,0,0,0,10.452,22.1a4.636,4.636,0,0,0-.128,9.25,4.532,4.532,0,0,0,4.692-4.22h6.426a4.58,4.58,0,0,0,9.127,0H33.72a1.04,1.04,0,0,0,1.023-1.057V16.568A4.162,4.162,0,0,0,30.65,12.341Zm-20.2,16.908a2.415,2.415,0,0,1-2.24-1.205,2.586,2.586,0,0,1,0-2.609,2.415,2.415,0,0,1,2.24-1.205,2.415,2.415,0,0,1,2.24,1.205,2.586,2.586,0,0,1,0,2.609A2.415,2.415,0,0,1,10.452,29.249Zm15.522,0a2.515,2.515,0,1,1,2.558-2.5A2.533,2.533,0,0,1,25.974,29.249Z",
    transform: "translate(-1.5 -5.5)",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogistics);
export default __webpack_public_path__ + "static/media/logistics.1cde3d389f2ba88ab487454af0743685.svg";
export { ForwardRef as ReactComponent };